import React from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import { LayoutRoute } from './Layouts';
import { LandingPage } from '../features/landingPage/LandingPage';
import { DirectSignup } from '../features/directSignup/DirectSignup';
import { LoginPage } from '../features/login/LoginPage';
import { DaasSignup } from '../features/daasSignup/DaasSignup';
import { BaasSignup } from '../features/baasSignup/BaasSignup';
import { RedirectError } from '../components/shared/errors/RedirectError/RedirectError';
import { Signup } from '../features/signup/Signup';
import { Login } from '../features/loginEmail/Login';

export const Routes = {
  home: '/',
  signup: '/services/signup',
  login: '/services/login',
  baasSignup: '/services/baas/signup',
  daasSignup: '/services/daas/signup',
  signupRedirectError: '/services/signup/error',
  hatSignup: '/hat/signup',
  hatLogin: '/hat/signin',
  hmi: '/hmi',
};

export const SandboxRoutes = {
  home: '/sandbox',
  hatSignup: '/sandbox/hat/signup',
  hatLogin: '/sandbox/hat/signin',
};

const AppRouter = () => (
  <Router>
    <Switch>
      <LayoutRoute exact path={Routes.home}>
        <LandingPage />
      </LayoutRoute>

      <LayoutRoute path={Routes.hatSignup}>
        <DirectSignup />
      </LayoutRoute>

      <LayoutRoute path={Routes.hatLogin}>
        <LoginPage />
      </LayoutRoute>

      <LayoutRoute path={Routes.daasSignup} issuedByFooter>
        <DaasSignup />
      </LayoutRoute>

      <LayoutRoute path={Routes.baasSignup} issuedByFooter>
        <BaasSignup />
      </LayoutRoute>

      <LayoutRoute path={Routes.signupRedirectError}>
        <RedirectError />
      </LayoutRoute>

      <LayoutRoute path={Routes.signup} issuedByFooter footerBackgroundColor="#fff">
        <Signup />
      </LayoutRoute>

      <LayoutRoute path={Routes.login} issuedByFooter footerBackgroundColor="#fff">
        <Login />
      </LayoutRoute>

      <LayoutRoute exact path={SandboxRoutes.home}>
        <LandingPage />
      </LayoutRoute>

      <LayoutRoute path={SandboxRoutes.hatSignup}>
        <DirectSignup />
      </LayoutRoute>

      <LayoutRoute path={SandboxRoutes.hatLogin}>
        <LoginPage />
      </LayoutRoute>
    </Switch>
  </Router>
);
export default AppRouter;
